import DomUtil from "../../../../../core/util/dom_util";
import { KeywordAction } from "../../../actions/keyword_action";
import { Keyword } from "../../../models/keyword";

export class SuggestionContainer{
    constructor() {
        KeywordAction.UPDATE_EVENT.on(
            this.refreshDOMAndCallInitScripts.bind(this)
        )
    }

    private refreshDOMAndCallInitScripts(model: Keyword) {
        const newHtml = model.getModel().htmlForRender!;
        const baloonId = model.getModel().baloonId;
        if (!baloonId) {
          return;
        }
        DomUtil.replace(
            newHtml,
            [`#${baloonId}`]
        );
    }
}
